import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GridManagement from './grid-management';

const GridManagementRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GridManagement />} />
  </ErrorBoundaryRoutes>
);

export default GridManagementRoutes;
